import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionIntro } from './components/SolutionIntro';
import { MainPackStack } from './components/MainPackStack';
import { BonusStack } from './components/BonusStack';
import { Differentiator } from './components/Differentiator';
import { SocialProof } from './components/SocialProof';
import { OfferPricing } from './components/OfferPricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { StickyBar } from './components/StickyBar';
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (!(window as any).fbq) {
      const n = ((window as any).fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      }) as any;
      if (!(window as any)._fbq) (window as any)._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      firstScript?.parentNode?.insertBefore(script, firstScript);
    }
    ;
    (window as any).fbq('init', '25533198362933091');
    (window as any).fbq('track', 'PageView');
  }, []);
  return <main className="min-h-screen w-full bg-[#FEFBF4] overflow-x-hidden" data-id="element-0">
      <Hero data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <SolutionIntro data-id="element-3" />
      <MainPackStack data-id="element-4" />
      <BonusStack data-id="element-5" />
      <Differentiator data-id="element-6" />
      <SocialProof data-id="element-7" />
      <OfferPricing data-id="element-8" />
      <Guarantee data-id="element-9" />
      <FAQ data-id="element-10" />
      <FinalCTA data-id="element-11" />
      <StickyBar data-id="element-12" />
    </main>;
}